export default __webpack_public_path__ + "static/logo-der-c4a077e18777182dff1075dd9adc1546.png";